module.exports = __webpack_public_path__ + "media/sayonara.32f6302a.mp3";